import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { BasecampLayout, AreaLayout } from '../../components/Layout';
import { PageHeader } from '../../components/UI';
import ChatPage from './ChatPage';
import ForumPage from './ForumPage';

// Community — Chat i Forum (port iz Compass-a). Member Directory je uklonjen:
// svi su na mapi "Where we are" (About Hansen Beck), odakle se otvara kartica osobe.

const SUBNAV = [
  { href: '/community/chat', label: 'Chat' },
  { href: '/community/forums', label: 'Forum' },
];

export default function Community() {
  const { sub } = useParams();
  if (!sub) return <Navigate to="/community/chat" replace />;

  let body;
  if (sub === 'chat') body = <ChatPage />;
  else if (sub === 'forums') body = <ForumPage />;
  else return <Navigate to="/community/chat" replace />;

  return (
    <BasecampLayout>
      <PageHeader title="Community" subtitle="The Hansen Becks — one community, one home" />
      <AreaLayout items={SUBNAV}>{body}</AreaLayout>
    </BasecampLayout>
  );
}
